export const messages = {
  en: {
    dataPrivilege: {
      title: 'Data Privilege',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      addTitle: 'Add Data Privilege',
      editTitle: 'Edit Data Privilege',
      deleteTitle: 'Delete Confirmation',
      name: 'Name',
      code: 'Code',
      remark: 'Remark',
      namePlaceholder: 'Please enter name',
      codePlaceholder: 'Please enter code',
      remarkPlaceholder: 'Please enter remark',
      nameRequired: 'Name is required',
      nameMaxLength: 'Name cannot exceed 50 characters',
      codeRequired: 'Code is required',
      codeMaxLength: 'Code cannot exceed 30 characters',
      remarkRequired: 'Remark is required',
      remarkMaxLength: 'Remark cannot exceed 256 characters',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      deleteConfirm: 'Are you sure to delete this data privilege?',
      confirmOperation: 'Please confirm your operation',
      unitAuth: 'Unit Authorization',
      staffRelation: 'Staff Relation',
      building: 'Building',
      unit: 'Unit',
      operation: 'Operation',
      associateUnit: 'Associate Unit',
      buildingUnit: 'Building Unit',
      inputBuildingNum: 'Input building number',
      inputUnitNum: 'Input unit number',
      buildingNum: 'Building Number',
      unitNum: 'Unit Number',
      confirmCancelUnit: 'Confirm to cancel building unit authorization?',
      associateSuccess: 'Association successful',
      staff: 'Staff',
      staffName: 'Staff Name',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      inputStaffName: 'Input staff name',
      inputPhone: 'Input phone number',
      inputStaffId: 'Input staff ID',
      staffId: 'Staff ID',
      staffAddress: 'Staff Address',
      associateStaff: 'Associate Staff',
      confirmCancelAuth: 'Confirm to cancel staff authorization?',
      detail: 'Detail'
    }
  },
  zh: {
    dataPrivilege: {
      title: '数据权限',
      add: '添加',
      edit: '修改',
      delete: '删除',
      addTitle: '添加数据权限',
      editTitle: '修改数据权限',
      deleteTitle: '删除确认',
      name: '名称',
      code: '编号',
      remark: '备注',
      namePlaceholder: '请输入名称',
      codePlaceholder: '请输入编号',
      remarkPlaceholder: '请输入备注',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过50个字符',
      codeRequired: '编号不能为空',
      codeMaxLength: '编号不能超过30个字符',
      remarkRequired: '备注不能为空',
      remarkMaxLength: '备注不能超过256个字符',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      deleteConfirm: '确定删除此数据权限吗？',
      confirmOperation: '请确认您的操作',
      unitAuth: '单元授权',
      staffRelation: '员工关联',
      building: '楼栋',
      unit: '单元',
      operation: '操作',
      associateUnit: '关联单元',
      buildingUnit: '楼栋单元',
      inputBuildingNum: '输入楼栋编号',
      inputUnitNum: '输入单元编号',
      buildingNum: '楼栋编号',
      unitNum: '单元编号',
      confirmCancelUnit: '确定取消楼栋单元授权吗？',
      associateSuccess: '关联成功',
      staff: '员工',
      staffName: '员工名称',
      phone: '手机号',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      male: '男',
      female: '女',
      inputStaffName: '输入员工名称',
      inputPhone: '输入手机号',
      inputStaffId: '输入员工编号',
      staffId: '员工编号',
      staffAddress: '员工地址',
      associateStaff: '关联员工',
      confirmCancelAuth: '确定取消员工授权吗？',
detail: '详情'
    }
  },
  'zh-TW': {
    dataPrivilege: {
      title: '數據權限',
      add: '添加',
      edit: '修改',
      delete: '刪除',
      addTitle: '添加數據權限',
      editTitle: '修改數據權限',
      deleteTitle: '刪除確認',
      name: '名稱',
      code: '編號',
      remark: '備註',
      namePlaceholder: '請輸入名稱',
      codePlaceholder: '請輸入編號',
      remarkPlaceholder: '請輸入備註',
      nameRequired: '名稱不能為空',
      nameMaxLength: '名稱不能超過50個字符',
      codeRequired: '編號不能為空',
      codeMaxLength: '編號不能超過30個字符',
      remarkRequired: '備註不能為空',
      remarkMaxLength: '備註不能超過256個字符',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      deleteConfirm: '確定刪除此數據權限嗎？',
      confirmOperation: '請確認您的操作',
      unitAuth: '單元授權',
      staffRelation: '員工關聯',
      building: '樓棟',
      unit: '單元',
      operation: '操作',
      associateUnit: '關聯單元',
      buildingUnit: '樓棟單元',
      inputBuildingNum: '輸入樓棟編號',
      inputUnitNum: '輸入單元編號',
      buildingNum: '樓棟編號',
      unitNum: '單元編號',
      confirmCancelUnit: '確定取消樓棟單元授權嗎？',
      associateSuccess: '關聯成功',
      staff: '員工',
      staffName: '員工名稱',
      phone: '手機號',
      email: '郵箱',
      address: '地址',
      gender: '性別',
      male: '男',
      female: '女',
      inputStaffName: '輸入員工名稱',
      inputPhone: '輸入手機號',
      inputStaffId: '輸入員工編號',
      staffId: '員工編號',
      staffAddress: '員工地址',
      associateStaff: '關聯員工',
      confirmCancelAuth: '確定取消員工授權嗎？',
      detail: '詳情'
    }
  }
}